import { split, HttpLink } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { APP_CONSTANTS } from "constants/AppConstants";
import { WebSocketLink } from "@apollo/client/link/ws";

export const httpLink = new HttpLink({
  uri: APP_CONSTANTS.gql_connection,
});

const wsLink = new WebSocketLink({
  uri: APP_CONSTANTS.gql_connection_wss,
  options: {
    reconnect: true,
  },
});

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value
export const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);
